import { renderDsAlert } from '../../../../../shared-ui/ds/alert.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

const ALERT_SIZES = new Set(['sm', 'md', 'lg']);
const ALERT_INTENTS = new Set(['error', 'success', 'warning', 'info']);

export function renderSettingsNotice(options = {}) {
  const normalized = withSettingsPresentationMode(options);
  const kind = String(normalized.kind || normalized.intent || 'info').trim().toLowerCase();
  const intent = ALERT_INTENTS.has(kind)
    ? kind
    : kind === 'ok'
      ? 'success'
      : kind === 'muted' || kind === 'loading' || kind === 'empty'
        ? 'info'
        : 'warning';
  const size = ALERT_SIZES.has(normalized.size) ? normalized.size : 'sm';
  const className = ['kg-settings-notice', String(normalized.className || '').trim()].filter(Boolean).join(' ');

  return renderDsAlert({
    ...normalized,
    intent,
    size,
    label: normalized.label == null ? '' : normalized.label,
    body: normalized.bodyHtml == null
      ? String(normalized.message || normalized.body || '')
      : undefined,
    bodyHtml: normalized.bodyHtml == null ? undefined : normalized.bodyHtml,
    footerHtml: normalized.footerHtml == null ? '' : normalized.footerHtml,
    className
  });
}
